'use strict';

var react = require('@emotion/react');

const chipBase = /*#__PURE__*/ react.css({
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "4px"
}, "label:label-Chip-web-styleschipBase", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9DaGlwL0NoaXAud2ViLnN0eWxlcy50cyIsInNvdXJjZXMiOlsiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9DaGlwL0NoaXAud2ViLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcblxuZXhwb3J0IGNvbnN0IGNoaXBCYXNlID0gY3NzKHtcbiAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBmbGV4V3JhcDogXCJ3cmFwXCIsXG4gIGdhcDogXCI0cHhcIixcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV3QiJ9 */");

exports.chipBase = chipBase;
//# sourceMappingURL=Chip.web.styles.cjs.map
